// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FinalStatus_statusContainer__773m0 {
  font-family: 'Segoe UI', sans-serif;
  color: #4a5568;
  border-radius: 12px;
  background-color: white;
  padding: 1.5rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
  
  /* Borde lateral izquierdo con el color del estado */
  border-left: 5px solid #ecc94b; /* Amarillo suave/ocre */
  
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: auto;
  min-width: 320px;
}
.FinalStatus_statusContainerResolved__ax2T1 {
  font-family: 'Segoe UI', sans-serif;
  color: #4a5568;
  border-radius: 12px;
  background-color: white;
  padding: 1.5rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
  
  /* Borde lateral izquierdo con el color del estado */
  border-left: 5px solid #69ec4b; /* Amarillo suave/ocre */
  
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: auto;
  min-width: 320px;
}
.FinalStatus_statusBadge__NssIT {
  display: inline-block;
  font-weight: 700;
  font-size: 0.8rem;
  padding: 5px 14px;
  border-radius: 6px;
  width: -moz-fit-content;
  width: fit-content;
  margin-top: -12px; /* Pequeño ajuste visual */
}

/* Estado específico: En proceso */
.FinalStatus_statusInProcess__kN9Ej {
  background-color: #fef9c3; /* Fondo amarillo muy pálido */
  color: #92400e;          /* Texto marrón oscuro para contraste */
  border: 1px solid #ecc94b;
}
.FinalStatus_statusResolved__wO-Vn {
  background-color: #d2fec3; /* Fondo amarillo muy pálido */
  color: #1a740c;          /* Texto marrón oscuro para contraste */
  border: 1px solid #66ec4b;
}
.FinalStatus_oddRemindText__z1Lvx {
  margin: 0;
  font-size: 0.95rem;
}

.FinalStatus_oddRemindText__z1Lvx strong {
  color: #2d3748;
}

/* Estilos de Acumulado */
.FinalStatus_accumulatedSection__rVxWq {
  margin-top: 8px;
  border-top: 1px solid #edf2f7;
  padding-top: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.FinalStatus_accumulatedLabel__4QdF6 {
  font-size: 0.85rem;
  color: #718096;
}

.FinalStatus_accumulatedValue__E9xUM {
  font-size: 0.95rem;
  font-weight: 600;
  color: #2d3748;
}`, "",{"version":3,"sources":["webpack://./src/components/modals-monitoreo/styles/FinalStatus.module.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kFAAkF;;EAElF,oDAAoD;EACpD,8BAA8B,EAAE,wBAAwB;;EAExD,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,mCAAmC;EACnC,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kFAAkF;;EAElF,oDAAoD;EACpD,8BAA8B,EAAE,wBAAwB;;EAExD,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,uBAAkB;EAAlB,kBAAkB;EAClB,iBAAiB,EAAE,0BAA0B;AAC/C;;AAEA,kCAAkC;AAClC;EACE,yBAAyB,EAAE,8BAA8B;EACzD,cAAc,WAAW,uCAAuC;EAChE,yBAAyB;AAC3B;AACA;EACE,yBAAyB,EAAE,8BAA8B;EACzD,cAAc,WAAW,uCAAuC;EAChE,yBAAyB;AAC3B;AACA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,6BAA6B;EAC7B,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":[".statusContainer {\r\n  font-family: 'Segoe UI', sans-serif;\r\n  color: #4a5568;\r\n  border-radius: 12px;\r\n  background-color: white;\r\n  padding: 1.5rem;\r\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);\r\n  \r\n  /* Borde lateral izquierdo con el color del estado */\r\n  border-left: 5px solid #ecc94b; /* Amarillo suave/ocre */\r\n  \r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  width: auto;\r\n  min-width: 320px;\r\n}\r\n.statusContainerResolved {\r\n  font-family: 'Segoe UI', sans-serif;\r\n  color: #4a5568;\r\n  border-radius: 12px;\r\n  background-color: white;\r\n  padding: 1.5rem;\r\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);\r\n  \r\n  /* Borde lateral izquierdo con el color del estado */\r\n  border-left: 5px solid #69ec4b; /* Amarillo suave/ocre */\r\n  \r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  width: auto;\r\n  min-width: 320px;\r\n}\r\n.statusBadge {\r\n  display: inline-block;\r\n  font-weight: 700;\r\n  font-size: 0.8rem;\r\n  padding: 5px 14px;\r\n  border-radius: 6px;\r\n  width: fit-content;\r\n  margin-top: -12px; /* Pequeño ajuste visual */\r\n}\r\n\r\n/* Estado específico: En proceso */\r\n.statusInProcess {\r\n  background-color: #fef9c3; /* Fondo amarillo muy pálido */\r\n  color: #92400e;          /* Texto marrón oscuro para contraste */\r\n  border: 1px solid #ecc94b;\r\n}\r\n.statusResolved {\r\n  background-color: #d2fec3; /* Fondo amarillo muy pálido */\r\n  color: #1a740c;          /* Texto marrón oscuro para contraste */\r\n  border: 1px solid #66ec4b;\r\n}\r\n.oddRemindText {\r\n  margin: 0;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.oddRemindText strong {\r\n  color: #2d3748;\r\n}\r\n\r\n/* Estilos de Acumulado */\r\n.accumulatedSection {\r\n  margin-top: 8px;\r\n  border-top: 1px solid #edf2f7;\r\n  padding-top: 12px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.accumulatedLabel {\r\n  font-size: 0.85rem;\r\n  color: #718096;\r\n}\r\n\r\n.accumulatedValue {\r\n  font-size: 0.95rem;\r\n  font-weight: 600;\r\n  color: #2d3748;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"statusContainer": `FinalStatus_statusContainer__773m0`,
	"statusContainerResolved": `FinalStatus_statusContainerResolved__ax2T1`,
	"statusBadge": `FinalStatus_statusBadge__NssIT`,
	"statusInProcess": `FinalStatus_statusInProcess__kN9Ej`,
	"statusResolved": `FinalStatus_statusResolved__wO-Vn`,
	"oddRemindText": `FinalStatus_oddRemindText__z1Lvx`,
	"accumulatedSection": `FinalStatus_accumulatedSection__rVxWq`,
	"accumulatedLabel": `FinalStatus_accumulatedLabel__4QdF6`,
	"accumulatedValue": `FinalStatus_accumulatedValue__E9xUM`
};
export default ___CSS_LOADER_EXPORT___;
